// extracted by mini-css-extract-plugin
export default {"legal":"Cookies_legal__IpJEg","root":"Cookies_root__E6dwk"};